<template>
  <div class="p-2 text-sm">
    <slot />
  </div>
</template>

<style scoped>
p {
    display: table-cell;
}
</style>